import { routes } from "../../routes";
import { HeaderWithMenu } from "../../shared/components/header-with-menu";
import { isNativePlatform } from "../../shared/utils/environment";
import { useCampingStation } from "../hooks/use-camping-station";
import { useCampingStationSlug } from "../hooks/use-camping-station-slug";

export const CampingHeader: React.FC = () => {
  // When making changes to this component, please be aware that it needs to work in an offline scenario (at least after the booking has been started).
  // The main use case is to open bluetooth locks without an internet connection.
  const campingStation = useCampingStation();
  const campingStationSlug = useCampingStationSlug();

  // Currently, the native app is promoted in the scenario where units are booked individually (via a QR code on the respective unit).
  // So for now, we redirect to the home page with the QR code scanner.
  // In the future, we might want to make this dependent on the entry point (e.g. store locally if user visited a station page first).
  const campingStationRentRoute = isNativePlatform()
    ? routes.home
    : routes.camping.rent.index(campingStationSlug);

  return (
    <HeaderWithMenu
      title={campingStation.name}
      homePath={campingStationRentRoute}
      menuItems={[{ name: "Neue Buchung", path: campingStationRentRoute }]}
    />
  );
};
